/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Alerts/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let alertsHasAlertsValueData = fromData.useDataValue({ viewPath,
context: 'alerts',
path: 'has_alerts',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(alertsHasAlertsValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}